import store from '../store/index'

let loading
let timer
// 当前正在请求的数量
let needLoadingRequestCount = 0

export default {
  // 显示loading
  showLoading() {
    // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
    // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
    if (needLoadingRequestCount === 0 && !loading) {
      store.commit('loading/setLoading', true)
    }
    if (timer) clearTimeout(timer)
    needLoadingRequestCount++
  },
  // 隐藏loading
  hideLoading() {
    needLoadingRequestCount--
    needLoadingRequestCount = Math.max(needLoadingRequestCount, 0) // 做个保护
    if (needLoadingRequestCount === 0) {
      // 关闭loading
      toHideLoading()
    }
  }
}

// 防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
let toHideLoading = function () {
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => {
    store.commit('loading/setLoading', false)
  }, 600)
}
